/**
 * Leadership and core team shown on the About page.
 * Add `image` (import or URL) when headshots are available; initials are used as fallback.
 */
export const teamMembers = [
  {
    name: "Jeffery Adolor",
    role: "Founder & CEO",
    bio: "Leads product vision, engineering, and strategy building CampusGenie into the app that stays with students from admission prep through graduation.",
    initials: "JA",
    linkedin: null,
    image: null,
  },
  {
    name: "CampusGenie Engineering",
    role: "Product & Platform",
    bio: "Ships the mobile app, Laravel API, and AI features that power daily study, campus tools, and student engagement at scale.",
    initials: "EN",
    linkedin: null,
    image: null,
  },
  {
    name: "CampusGenie Growth",
    role: "Campus & Community",
    bio: "Runs ambassador programs, campus activations, and partnerships that put CampusGenie in front of students where they already are.",
    initials: "GR",
    linkedin: null,
    image: null,
  },
];
